import './filters.scss';

import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';
import { BoxTabs } from 'commonsComponents/boxTabs';
import { InputSafe } from 'commonsComponents/inputSafe';
import { recordLinkV2 } from 'utilities/tagging';
import { IA_INVESTMENT_HOME_INTERACTIONS } from 'constants/tagging';

import PredictionMarketsActions from 'actions/brokerIA/brokerIAGetPredictionMarkets';
import OKSelect from 'components/commons/OKSelect/OKSelect';

const { formatText } = i18n;

const Filters = ({
    compact = false,
    country = 'ES',
    filtersData: {
        month,
        handleMonth,
        order,
        handleOrder,
        market,
        handleMarket,
        asset,
        handleAsset,
    },
    predictionMarkets,
    getPredictionMarkets,
}) => {
    useEffect(() => {
        if (!compact) {
            getPredictionMarkets({ country });
        }
    }, []);

    const orderTabLabels = compact
        ? [
              formatText('brokerIA-order_label_growth_compact'),
              formatText('brokerIA-order_label_decline_compact'),
          ]
        : [formatText('brokerIA-order_label_growth'), formatText('brokerIA-order_label_decline')];

    const monthsTabLabels = [
        formatText('brokerIA-months_label_1Month'),
        formatText('brokerIA-months_label_3Month'),
        formatText('brokerIA-months_label_6Month'),
        formatText('brokerIA-months_label_12Month'),
    ];

    const formattedMarkets = [
        { value: false, label: formatText('brokerIA-filters_placeholder_market') },
        ...(!!predictionMarkets.get('markets')
            ? predictionMarkets
                  .get('markets')
                  .map(({ micCode, description }) => ({ value: micCode, label: formatText('brokerIA-filters_market_label_'+micCode) }))
            : {}),
    ];

    const className = classNames('brokerIA-filters', { 'brokerIA-filters--compact': compact });

    const recordAssetClick = () => {
        recordLinkV2({
            categoriaEvento: IA_INVESTMENT_HOME_INTERACTIONS,
            accionEvento: 'clickTextBox',
            etiquetaEvento: 'stockISINOrName',
        });
    };

    const recordMarketPickerStateChange = open => {
        recordLinkV2({
            categoriaEvento: IA_INVESTMENT_HOME_INTERACTIONS,
            accionEvento: 'marketDropdown',
            etiquetaEvento: open ? 'open' : 'close',
        });
    };

    const onMarketOpen = () => {
        recordMarketPickerStateChange(true);
    };

    const onMarketClose = () => {
        recordMarketPickerStateChange(false);
    };

    return (
        <div className={className}>
            {!compact && (
                <div className="brokerIA-filters__row">
                    <div>
                        <div className="brokerIA-filters__filterTitle">
                            <strong>{formatText('brokerIA-filters_title_name')}</strong>
                        </div>
                        <InputSafe
                            placeholder={formatText('brokerIA-filters_placeholder_name')}
                            autoComplete="off"
                            type="text"
                            value={asset}
                            onChange={handleAsset}
                            onFocus={recordAssetClick}
                        />
                    </div>
                    <div>
                        <div className="brokerIA-filters__filterTitle">
                            <strong>{formatText('brokerIA-filters_title_market')}</strong>
                        </div>
                        <OKSelect
                            options={formattedMarkets}
                            onOpen={onMarketOpen}
                            onClose={onMarketClose}
                            onChange={handleMarket}
                            value={market.value}
                            searchable={false}
                            loading={predictionMarkets.get('isFetching')}
                            disabled={predictionMarkets.get('error')}
                        />
                    </div>
                </div>
            )}
            <div className="brokerIA-filters__row">
                <div>
                    <div className="brokerIA-filters__filterTitle">
                        <strong>{formatText('brokerIA-filters_title_months')}</strong>
                    </div>
                    <BoxTabs
                        tabs={monthsTabLabels}
                        activeTab={month}
                        handleSelectedTab={handleMonth}
                        tabsAsPills
                    />
                </div>
                <div>
                    <div className="brokerIA-filters__filterTitle">
                        <strong>{formatText('brokerIA-filters_title_order')}</strong>
                    </div>
                    <BoxTabs
                        tabs={orderTabLabels}
                        activeTab={order}
                        handleSelectedTab={handleOrder}
                        tabsAsPills
                    />
                </div>
            </div>
        </div>
    );
};

Filters.propTypes = {
    compact: PropTypes.Boolean,
    country: PropTypes.String,
    filtersData: PropTypes.object.isRequired,
    predictionMarkets: PropTypes.object,
    getPredictionMarkets: PropTypes.func,
};

export default connect(
    state => ({
        predictionMarkets: state.brokerIAPredictionMarkets,
    }),
    {
        getPredictionMarkets: PredictionMarketsActions.getPredictionMarkets,
    }
)(Filters);
